import { createSelector } from '@reduxjs/toolkit';
import { tournamentsAdapter } from '~SpectateStore/slices/tournamentsSlice';
import { selectEventTournamentId } from './eventsSelectors';

export const {
    selectById: selectTournamentById,
} = tournamentsAdapter.getSelectors(state => state.tournaments);

export const selectTournamentSlug = (state, tournamentId) => selectTournamentById(state, tournamentId)?.slug;
export const selectTournamentLogos = (state, tournamentId) => selectTournamentById(state, tournamentId)?.logos ?? [];

export const selectTournamentLogosByEventId = createSelector(
    [
        state => state,
        selectEventTournamentId,
    ],
    (state, tournamentId) => selectTournamentLogos(state, tournamentId),
);

export const selectTournamentSlugByEventId = createSelector(
    [
        state => state,
        selectEventTournamentId,
    ],
    (state, tournamentId) => selectTournamentSlug(state, tournamentId),
);

export const selectShowTeamLogo = (state, eventId) => selectTournamentLogosByEventId(state, eventId)?.showTeamLogo;

export const selectShowAwayJersey = (state, eventId) => selectTournamentLogosByEventId(state, eventId)?.showAwayJersey;
